import { z } from 'zod';

import { addressVMSchema, addressInitial } from './address.vm';

/** Billing details ViewModel schema. */
export const billingDetailsVMSchema = z.object({
  firstName: z.string(),
  secondName: z.string(),
  location: addressVMSchema,
});

/** Billing details ViewModel. */
export type BillingDetailsVM = z.infer<typeof billingDetailsVMSchema>;

/** Initial values. */
export const billingDetailsInitial: BillingDetailsVM = {
  firstName: '',
  secondName: '',
  location: addressInitial,
};
